import { Button, Skeleton } from "antd";
import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const Sidebar = props => {
  const {
    personCount,
    driver,
    vehicle,
    orderStatusName,
    goBack,
    responsible
  } = props;
  const arrivalDatetime =
    props.arrivalDatetime && moment(props.arrivalDatetime);

  const { responsibleId } = responsible;
  const responsibleName =
    responsible &&
    responsible.userId &&
    responsible.userId.lastname &&
    responsible.userId.name &&
    responsible.userId.patronymic &&
    `${responsible.userId.lastname ? responsible.userId.lastname : ""} ${
      responsible.userId.name ? responsible.userId.name[0] + "." : ""
    } ${
      responsible.userId.patronymic
        ? responsible.userId.patronymic[0] + "."
        : ""
    }`;

  return (
    <div className="order-list-sidebar">
      {/*<Button className="order-list-sidebar__button" type="primary" block ghost>*/}
      {/*  Импортировать список*/}
      {/*</Button>*/}
      <Button
        className="order-list-sidebar__button"
        type="danger"
        size="large"
        block
        ghost
        onClick={goBack}
      >
        Назад
      </Button>
      <div className="order-list-sidebar__block block">
        <span className="block__label">Количество пасс:</span>
        <span className="block__text">{personCount || 0}</span>
      </div>
      <div className="order-list-sidebar__block block">
        {driver ||
        (vehicle && vehicle.vehicleId) ||
        (responsibleName && responsibleId) ||
        (vehicle && vehicle.vehicle) ? (
          <div className="block__list">
            {driver && (
              <div className="block__list-item">
                <span className="block__label">Водитель</span>
                <Link
                  to={`/employees/${driver.driverId}`}
                  className="block__text color-text-blue"
                >
                  {driver.driver}
                </Link>
              </div>
            )}
            {vehicle && (
              <div className="block__list-item">
                <span className="block__label">ТС</span>
                <Link
                  to={`/vehicle_card/${vehicle.vehicleId}`}
                  className="block__text color-text-blue"
                >
                  {vehicle.vehicle}
                </Link>
              </div>
            )}
            {responsibleName && responsibleId && (
              <div className="block__list-item">
                <span className="block__label">Ответств.</span>
                <Link
                  to={`/employees/${responsible.responsibleId}`}
                  className="block__text color-text-blue"
                >
                  {responsibleName}
                </Link>
              </div>
            )}
          </div>
        ) : (
          <Skeleton active />
        )}
      </div>
      <div className="order-list-sidebar__block block">
        {(orderStatusName && arrivalDatetime && (
          <div className="block__list">
            <div className="block__title">Статус заказа</div>
            <div className="block__list-item">
              <span className="block__label">{orderStatusName}</span>
              <span className="block__text">
                {arrivalDatetime.format("DD.MM.YYYY")}
              </span>
            </div>
            {/*<div className="block__list-item">*/}
            {/*  <span className="block__label">Принят</span>*/}
            {/*  <span className="block__text color-text-grey">31.03.2019</span>*/}
            {/*</div>*/}
          </div>
        )) || <Skeleton active />}
      </div>
    </div>
  );
};

export default Sidebar;
